import { fetcher } from "helpers/fetcher";

import { TPublishJobListingReq, TPublishJobListingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const publishJobListing = async (payload?: TPublishJobListingReq) => {
  return await fetcher<TPublishJobListingRes, TPublishJobListingReq["data"]>(
    ENDPOINT.CORPORATION.PUBLISH_JOB_LISTING,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.PUBLISH_JOB_LISTING.version,
        [API_HEADER.CORP_ID]: payload?.idCorp,
      },
    }
  );
};

export const mutationPublishJobListing = async (
  payload?: TPublishJobListingReq
) => {
  return (await publishJobListing(payload)).data;
};

mutationPublishJobListing._key = (payload?: TPublishJobListingReq) => [
  ENDPOINT.CORPORATION.PUBLISH_JOB_LISTING.url,
  payload,
];
